import React from 'react';
import { Link } from '@material-ui/core';
import { useSelector } from 'react-redux';

import { Button } from '@components';
import { getOrderDocument } from '@api/api';
import { retrieveAccessToken } from '@utils/auth';
import { getLocalizedContent as l } from '@helpers/languages';
import content from './ViewOrderButton.json';

const fetchReceipt = async orderId => {
  try {
    const token = retrieveAccessToken();
    const orderDocumentResponse = await getOrderDocument(token, `${orderId}`, {
      responseType: 'arraybuffer',
    });

    const orderDocumentBlob = new Blob([orderDocumentResponse], {
      type: 'application/pdf',
    });

    // IE doesn't allow using a blob object directly as link href
    // instead it is necessary to use msSaveOrOpenBlob
    if (window.navigator && window.navigator.msSaveOrOpenBlob) {
      window.navigator.msSaveOrOpenBlob(orderDocumentBlob);
      return;
    }

    const URL = window.URL || window.webkitURL;
    const confirmationURL = URL.createObjectURL(orderDocumentBlob);

    window.open(confirmationURL, '_blank');

    setTimeout(() => URL.revokeObjectURL(confirmationURL), 100);
  } catch (err) {
    // eslint-disable-next-line no-console
    console.log({ err });
  }
};

export const ViewOrderButtonDesktop = ({ orderId }) => {
  const { prefixLanguage } = useSelector(({ appState }) => appState);
  const language = prefixLanguage || 'en';

  return (
    <Button
      data-cy="data-view-order-button"
      onClick={async () => await fetchReceipt(orderId)}
      data-view-order-desktop
      text={l(content.title, language)}
      height="64px"
      hoverColor="#1B1B1B"
      style={{
        background: 'transparent',
        border: '1px solid #1B1B1B',
        color: '#1B1B1B',
      }}
    />
  );
};

export const ViewOrderButtonMobile = ({ orderId }) => {
  const { prefixLanguage } = useSelector(({ appState }) => appState);
  const language = prefixLanguage || 'en';

  return (
    <Link
      data-cy="data-view-order-link"
      data-view-order-mobile
      onClick={async () => await fetchReceipt(orderId)}
    >
      {l(content.title, language)}
    </Link>
  );
};
